var _defs, _rect, _path, _circle, _g, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvexOptimization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34d399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0ea5e9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 480,
    rx: 24,
    fill: "url(#grad3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 360 Q160 220 270 360",
    fill: "none",
    stroke: "rgba(15,23,42,0.35)",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 260,
    r: 22,
    fill: "#0f172a",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(15,23,42,0.72)",
    fontFamily: "'Poppins', 'Segoe UI', sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 190,
    fontSize: 42,
    fontWeight: 700
  }, "Convex"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 240,
    fontSize: 42,
    fontWeight: 700
  }, "Optimization"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 200,
    height: 12,
    rx: 6,
    fill: "rgba(15,23,42,0.25)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 160,
    height: 12,
    rx: 6,
    fill: "rgba(15,23,42,0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvexOptimization);
export default __webpack_public_path__ + "static/media/convex-optimization.ee376bb48e90a4d97884f331c8475b78.svg";
export { ForwardRef as ReactComponent };